import { ImageObject, ImageType } from '@website/components/seo';

export const roundTo = (number: string, precision = 2) =>
  (Math.round(parseFloat(number || '0') * 100) / 100).toFixed(precision);

export const maxFinance = 400.0;
export const payLaterDownPayment = 0;

export const getQueryStringValue = (key: string) => {
  if (typeof window !== 'undefined') {
    return decodeURIComponent(
      window.location.search.replace(
        new RegExp(
          `^(?:.*[&\\?]${encodeURIComponent(key).replace(
            /[.+*]/g,
            '\\$&'
          )}(?:\\=([^&]*))?)?.*$`,
          'i'
        ),
        '$1'
      )
    );
  }
  return null;
};

const easeInOutQuad = (t: number, b: number, c: number, d: number) => {
  t /= d / 2;
  if (t < 1) return (c / 2) * t * t + b;
  t--;
  return (-c / 2) * (t * (t - 2) - 1) + b;
};

const handleAnimatedScroll = (e: any, to = 0, duration = 500) => {
  const element = document.scrollingElement || document.documentElement;
  const start = element.scrollTop;
  const change = to - start;
  let currentTime = 0;
  const increment = 20;

  const animateScroll = () => {
    currentTime += increment;
    const val = easeInOutQuad(currentTime, start, change, duration);
    element.scrollTop = val;
    if (currentTime < duration) {
      setTimeout(animateScroll, increment);
    }
  };
  animateScroll();
};

export const handleCustomScroll = (toElementId: string) => {
  let pageYOffset = 0;
  if (typeof window !== 'undefined') {
    ({ pageYOffset } = window);
  }
  const distance =
    (document?.querySelector?.(toElementId)?.getBoundingClientRect?.()?.top ||
      0) + pageYOffset;
  handleAnimatedScroll(null, distance);
};

export const getMagentoProducts = (props: any) => {};

export const toCents = (price: string | number) =>
  Number((parseFloat(`${price || 0}`) * 100).toFixed(0));

export const toDollars = (price: string | number) =>
  Number((parseFloat(`${price || 0}`) / 100).toFixed(2));

export const getImageByName = (images?: ImageObject[] | null, name: string) => {
  let image: ImageType = {
    id: '',
    title: '',
    url: 'https://www.datocms-assets.com/10154/1556724983-cove-icon.png',
    alt: 'Cove Logo',
  };

  if (!images) {
    return image;
  }

  const returnedImage = images.find((image) => image.name === name)?.image;

  if (returnedImage) {
    image = returnedImage;
  }

  if (!returnedImage) {
    const options = images.map((img) => img.name);
    console.warn(
      `Could not find image with name ${name}. Available options: ${options}`
    );
  }

  return image;
};

interface FadeSlideShowReview {
  id: string;
  customerName: string;
  customerReview: string;
  reviewDate: string;
}

//* Used to transform the fadeslideshowreviews coming from DatoCMS to a usable format for the existing reviews being used in the FadeSlideShow component */

export const transformReview = (
  reviews: FadeSlideShowReview[] | null
): {
  id: string;
  name: string;
  date: string;
  review: string;
}[] => {
  if (!reviews) {
    console.warn('Missing reviews to transform');
    return [];
  }
  return reviews.map(({ customerName, customerReview, reviewDate, id }) => ({
    id,
    name: customerName,
    date: reviewDate,
    review: customerReview,
  }));
};

export const groupArrayIntoPairs = <T>(arr: T[]): T[][] => {
  const result: T[][] = [];

  for (let i = 0; i < arr.length; i += 2) {
    const pair: T[] = [];

    if (i < arr.length) {
      pair.push(arr[i]);
    }

    if (i + 1 < arr.length) {
      pair.push(arr[i + 1]);
    }

    result.push(pair);
  }

  return result;
};
